(function ($) {
    $(function () {
        var wordsPerMinute = 200; // Average case.

        $('.read-time').each(function (e) {
            var text = $('.article-content').text();

            var result;

            var textLength = text.split(' ').length; // Split by words
            if (textLength > 0) {
                var value = Math.ceil(textLength / wordsPerMinute);
                result = '~' + value + ' min read';
            }
            $('.estimated-read-time').text(result);
        });
    });
})($JQ);